import type { StageState } from './types';

// `number` is a text colour of its own because core `Text` sets `color`, so the marker's colour
// cannot reach the number through it. The tick uses `currentColor` and takes it from the marker.
export const STAGE_APPEARANCE: Record<StageState, { marker: string; number: string; label: string }> = {
  done: { marker: 'bg-green-600', number: 'text-white', label: 'text-slate-800' },
  current: { marker: 'bg-blue-600', number: 'text-white', label: 'text-blue-700' },
  // An outline, because a filled marker reads as "happened".
  ahead: {
    marker: 'border-1 border-solid border-slate-300 bg-white',
    number: 'text-slate-500',
    label: 'text-slate-500',
  },
};
